import React from "react"
import gql from "graphql-tag"
import PropTypes from "prop-types"

import {Query as QueryComponent} from "../"
import {driver, team} from "../../gql"


export const query = gql`
  query TeamDriverAverageList(
    $params: TeamDriverAverageListParams!
    $headerParams: BatchInsightsReportingParams!
  ) {
    teamDriverAverageList(params: $params) {
      results {
        averageScore
        answerCount
        teamId
        team { ${team} }
        driverId
        driver { ${driver} }
      }
      total
      count
    }
    batchInsightsReporting(params: $headerParams) {
      answersAverage
      params {
        driverId
      }
    }
   }`


const TeamDriverAverageListQuery = ({children, params, headerParams, ...props}) => {
  return (
    <QueryComponent
      {...props}
      variables={{params, headerParams}}
      query={query}>
      {({data, historicalData, ...apolloState}) => {
        return children({data, historicalData, ...apolloState})
      }}
    </QueryComponent>
  )
}

TeamDriverAverageListQuery.propTypes = {
  children: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired
}


export default TeamDriverAverageListQuery
